import { SecureClient } from '../../../utils';

const submitNachCancellationRequestAPICall = ({
  customerCredentials,
  payload,
  successFn,
  errorFn,
  finallyFn,
}) => {
  const { customerId, Authorization, customerRefNum } = customerCredentials;
  SecureClient({
    isEncrypted: true,
    customerId,
    otherPayloadDetailsPresent: true,
    route: 'razorpay_service/payment_service',
    headers: {
      Authorization,
    },
    payload,
    successFn,
    errorFn,
    finallyFn,
  });
};

export default submitNachCancellationRequestAPICall;
